<nav class="navbar navbar-expand-xl bg-custom boxshadow fixed-top">
  <a class="navbar-brand" routerLink="/">
    <span>
      <img class="logo" src="./assets/images/logo_new.png">
    </span>
  </a>
  <button class="navbar-toggler" (click)="isMenuCollapsed = !isMenuCollapsed">
    &#9776;
  </button>

  <div id="wwtp" class="collapse navbar-collapse" [ngbCollapse]="isMenuCollapsed">
    <ul class="navbar-nav ms-auto" style="margin-top: -4px;">
      <li class="nav-item" ngbDropdown #libraryDropdown="ngbDropdown"
        (mouseenter)="openDropdownOnHover(libraryDropdown, $event)"
        (mouseleave)="closeDropdownOnLeave(libraryDropdown, $event)"
        (openChange)="onDropdownOpenChange(libraryDropdown, $event)">
        <a class="nav-link text-white text-uppercase" ngbDropdownToggle id="systemAdmin" role="button">
          LIBRARY <i class="fa fa-angle-down" aria-hidden="true"></i>
        </a>

        <ul ngbDropdownMenu aria-labelledby="systemAdmin"
          class="dropdown-menu bg-light top-52px shadow user-menus border-none">

          <li ngbDropdown placement="right" #moduleSettingsDropdown="ngbDropdown"
            (mouseenter)="openDropdownOnHover(moduleSettingsDropdown, $event)"
            (mouseleave)="closeDropdownOnLeave(moduleSettingsDropdown, $event)"
            (openChange)="onDropdownOpenChange(moduleSettingsDropdown, $event)">
            <a class="sub-dropdown" id="module" ngbDropdownToggle>Modules Settings
              <i class="fa fa-caret-right float-end mt-5px" aria-hidden="true"></i></a>
            <div class="dropdown-divider"></div>
            <div ngbDropdownMenu aria-labelledby="static"
              class="dropdown-menu bg-light user-menus  sub-dropdown-menu user_role">
          <li ngbDropdown placement="right" #processModuleDropdown="ngbDropdown"
            (mouseenter)="openDropdownOnHover(processModuleDropdown, $event)"
            (mouseleave)="closeDropdownOnLeave(processModuleDropdown, $event)"
            (openChange)="onDropdownOpenChange(processModuleDropdown, $event)">
            <a class="sub-dropdown" id="analysis" ngbDropdownToggle>Process Module <i
                class="fa fa-caret-right float-end mt-5px" aria-hidden="true"></i></a>
            <div ngbDropdownMenu aria-labelledby="analysis"
              class="dropdown-menu bg-light user-menus  sub-dropdown-menu drop_one">
              <a routerLink="/systemadminlibrary/addModule" ngbDropdownItem>Add Module</a>
              <div class="dropdown-divider"></div>
              <a routerLink="/systemadminlibrary/genericlibrary" ngbDropdownItem>Edit Module</a>
            </div>
          </li>
          <li ngbDropdown placement="right" #opexModuleDropdown="ngbDropdown"
            (mouseenter)="openDropdownOnHover(opexModuleDropdown, $event)"
            (mouseleave)="closeDropdownOnLeave(opexModuleDropdown, $event)"
            (openChange)="onDropdownOpenChange(opexModuleDropdown, $event)">
            <div class="dropdown-divider"></div>
            <a class="sub-dropdown" id="analysis" ngbDropdownToggle>OPEX Module <i
                class="fa fa-caret-right float-end mt-5px" aria-hidden="true"></i></a>
            <div ngbDropdownMenu aria-labelledby="analysis"
              class="dropdown-menu bg-light user-menus  sub-dropdown-menu drop_one one">
              <a routerLink="/opexmodule/addmodule" ngbDropdownItem>Add Module</a>
              <div class="dropdown-divider"></div>
              <a routerLink="/opexmodule/editmodule" ngbDropdownItem>Edit Module</a>
            </div>
          </li>
          <li ngbDropdown placement="right" #safetyModuleDropdown="ngbDropdown"
            (mouseenter)="openDropdownOnHover(safetyModuleDropdown, $event)"
            (mouseleave)="closeDropdownOnLeave(safetyModuleDropdown, $event)"
            (openChange)="onDropdownOpenChange(safetyModuleDropdown, $event)">
            <div class="dropdown-divider"></div>
            <a class="sub-dropdown" id="analysis" ngbDropdownToggle>Safety Module <i
                class="fa fa-caret-right float-end mt-5px" aria-hidden="true"></i></a>
            <div ngbDropdownMenu aria-labelledby="analysis"
              class="dropdown-menu bg-light user-menus  sub-dropdown-menu drop_one">
              <a routerLink="/safety/addmodule" ngbDropdownItem>Add Module</a>
              <div class="dropdown-divider"></div>
              <a routerLink="/safety/editmodule" ngbDropdownItem>Edit Module</a>
            </div>
          </li>
          <li ngbDropdown placement="right" #equipmentModuleDropdown="ngbDropdown"
            (mouseenter)="openDropdownOnHover(equipmentModuleDropdown, $event)"
            (mouseleave)="closeDropdownOnLeave(equipmentModuleDropdown, $event)"
            (openChange)="onDropdownOpenChange(equipmentModuleDropdown, $event)">
            <div class="dropdown-divider"></div>
            <a class="sub-dropdown" id="analysis" ngbDropdownToggle>Equipment Module <i
                class="fa fa-caret-right float-end mt-5px" aria-hidden="true"></i></a>
            <div ngbDropdownMenu aria-labelledby="analysis"
              class="dropdown-menu bg-light user-menus  sub-dropdown-menu drop_one">
              <a routerLink="/equipment/addmodule" ngbDropdownItem>Add Module</a>
              <div class="dropdown-divider"></div>
              <a routerLink="/equipment/editmodule" ngbDropdownItem>Edit Module</a>
            </div>
          </li>
  </div>
  </li>
  <li ngbDropdown placement="bottom-right">
    <a class="sub-dropdown" id="Corporation" routerLink="/useradminlib/useradmin">User Setting </a>
    <div class="dropdown-divider"></div>
  </li>
  <li ngbDropdown placement="bottom-right">
    <a class="sub-dropdown" routerLink="/site/allgoogleuser">User Profile Settings</a>
    <div class="dropdown-divider"></div>
  </li>
  <li ngbDropdown placement="bottom-right">
    <a class="sub-dropdown" routerLink="/site/user-request">User Profile Settings (New)</a>
    <div class="dropdown-divider"></div>
  </li>

  <li ngbDropdown placement="bottom-right">
    <a class="sub-dropdown" id="Corporation" routerLink="/useradminlib/user-role">User Role </a>
    <div class="dropdown-divider"></div>
  </li>

  <li ngbDropdown placement="bottom-right">
    <a class="sub-dropdown" id="role-access" routerLink="/role">Role Access</a>
    <div class="dropdown-divider"></div>
  </li>

  <li ngbDropdown placement="bottom-right">
    <a class="sub-dropdown" id="report-user-role" routerLink="/report-system/admin/permissions">Report User
      Management</a>
    <div class="dropdown-divider"></div>
  </li>
  <!-- <li ngbDropdown placement="bottom-right">
    <a class="sub-dropdown" id="Corporation" routerLink="/category/editcategory">Categories Settings </a>
     <div class="dropdown-divider"></div>
  </li> -->
  <li ngbDropdown placement="right" #categoriesDropdown="ngbDropdown"
    (mouseenter)="openDropdownOnHover(categoriesDropdown, $event)"
    (mouseleave)="closeDropdownOnLeave(categoriesDropdown, $event)"
    (openChange)="onDropdownOpenChange(categoriesDropdown, $event)">
    <a class="sub-dropdown" id="Corporation" ngbDropdownToggle>Categories
      <i class="fa fa-caret-right float-right mt-5px" aria-hidden="true"></i></a>
    <div class="dropdown-divider"></div>
    <div ngbDropdownMenu aria-labelledby="static"
      class="dropdown-menu bg-light user-menus  sub-dropdown-menu user_role">
  <li ngbDropdown placement="right">
    <a class="sub-dropdown" id="Corporation" routerLink="/corporation/categories-settings">Categories Settings </a>
  </li>
  <li ngbDropdown placement="right">
    <div class="dropdown-divider"></div>
    <a class="sub-dropdown" id="Corporation" routerLink="/category/editcategory">Sub Categories Settings </a>
  </li>
   <li ngbDropdown placement="right">
    <div class="dropdown-divider"></div>
    <a class="sub-dropdown" id="Corporation" [routerLink]="['/equipment/equipmentsetting']"
      [queryParams]="{categoryEquipmentSetting: true}">Equipment Settings </a>
  </li>
  <li ngbDropdown placement="right">
    <div class="dropdown-divider"></div>
    <a class="sub-dropdown" id="Corporation" [routerLink]="['/reportlibrary/subcategory-report-settings']"
      [queryParams]="{subCategoryReportSetting: true}">Report Settings </a>
  </li>
  <li ngbDropdown placement="right">
    <div class="dropdown-divider"></div>
    <a class="sub-dropdown" id="Corporation" [routerLink]="['/newalerts/alertlist']"
      [queryParams]="{categoryAlertSetting: true}">Alerts Settings </a>
  </li>
  </div>
  </li>
  <li ngbDropdown placement="bottom-right">
    <a class="sub-dropdown" id="Corporation" routerLink="/useradminlib/system-experts"> CS Experts Settings </a>
    <div class="dropdown-divider"></div>
  </li>
  <li ngbDropdown placement="bottom-right">
    <a class="sub-dropdown" routerLink="/ai-topic-settings"> AI Topic Settings </a>
  </li>

  <!-- <a ngbDropdownItem routerLink="/ai-topic-settings">AI Topic Settings</a>
      <div class="dropdown-divider"></div> -->
  </ul>
  </li>

   <li class="nav-item" ngbDropdown #corpDropdown="ngbDropdown"
     (mouseenter)="openDropdownOnHover(corpDropdown, $event)"
     (mouseleave)="closeDropdownOnLeave(corpDropdown, $event)"
     (openChange)="onDropdownOpenChange(corpDropdown, $event)">
    <a class="nav-link text-white text-uppercase" ngbDropdownToggle id="systemAdmin" role="button">
      CORP <i class="fa fa-angle-down" aria-hidden="true"></i>
    </a>
    <ul ngbDropdownMenu aria-labelledby="systemAdmin"
      class="dropdown-menu bg-light top-52px shadow border-none user-menus">
      <a ngbDropdownItem routerLink="/corporation/edit-corp">Corp Setting</a>
      <div class="dropdown-divider"></div>
      <a ngbDropdownItem routerLink="/corporation/manage-corp-user">Corp User Setting</a>
      <div class="dropdown-divider"></div>
      <a class="sub-dropdown" id="Corporation" routerLink="/corporation/user-role">Corp User Role </a>
      <div class="dropdown-divider"></div>
      <a ngbDropdownItem routerLink="/corporation/edit-corp-site"> Sites Settings</a>
    </ul>
  </li>

  <li class="nav-item" ngbDropdown #siteDropdown="ngbDropdown"
    (mouseenter)="openDropdownOnHover(siteDropdown, $event)"
    (mouseleave)="closeDropdownOnLeave(siteDropdown, $event)"
    (openChange)="onDropdownOpenChange(siteDropdown, $event)">
    <a class="nav-link text-white text-uppercase" ngbDropdownToggle id="systemAdmin" role="button">
      SITE <i class="fa fa-angle-down" aria-hidden="true"></i>
    </a>
    <ul ngbDropdownMenu aria-labelledby="systemAdmin"
      class="dropdown-menu bg-light top-52px shadow border-none user-menus">
      <a ngbDropdownItem routerLink="/site/allsiteuser">Site Users Settings</a>
      <div class="dropdown-divider"></div>
      <a ngbDropdownItem routerLink="/site/createsiteuser">Create Site User</a>
      <div class="dropdown-divider"></div>
      <a
        *ngIf="currentUser?.role == 1 || currentUser?.user_role == 1"
        ngbDropdownItem
        href="javascript:void(0)"
        (click)="openResetPasswordModal(resetPasswordModal)">
        Reset User Password
      </a>
      <div
        *ngIf="currentUser?.role == 1 || currentUser?.user_role == 1"
        class="dropdown-divider"></div>

      <a class="sub-dropdown" id="Corporation" routerLink="/site/user-role">Site User Role </a>
      <div class="dropdown-divider"></div>
      <a ngbDropdownItem routerLink="/site/allsite"> Sites Settings</a>
      <div class="dropdown-divider"></div>
      <li ngbDropdown placement="bottom-right" #alertsSettingsDropdown="ngbDropdown"
        (mouseenter)="openDropdownOnHover(alertsSettingsDropdown, $event)"
        (mouseleave)="closeDropdownOnLeave(alertsSettingsDropdown, $event)"
        (openChange)="onDropdownOpenChange(alertsSettingsDropdown, $event)">
        <a class="sub-dropdown" id="Dashboard" ngbDropdownToggle>Alerts Settings<i
            class="fa fa-caret-right  float-end mt-5px" aria-hidden="true"></i></a>
        <div ngbDropdownMenu aria-labelledby="Dashboard"
          class="dropdown-menu bg-light user-menus sub-dropdown-menu drop_one">
          <a ngbDropdownItem routerLink="/alerts/pmalerts"> PM Alerts</a>
          <div class="dropdown-divider"></div>
          <a ngbDropdownItem routerLink="/alerts/modulealerts"> Module Alerts</a>
          <div class="dropdown-divider"></div>
          <a ngbDropdownItem routerLink="/alerts/parameteralerts"> Parameters Alerts</a>
          <div class="dropdown-divider"></div>
          <a ngbDropdownItem routerLink="/alerts/opexalerts"> Opex Alerts</a>
        </div>
        <div class="dropdown-divider"></div>
      </li>
      <li ngbDropdown placement="right" #dashboardsDropdown="ngbDropdown"
        (mouseenter)="openDropdownOnHover(dashboardsDropdown, $event)"
        (mouseleave)="closeDropdownOnLeave(dashboardsDropdown, $event)"
        (openChange)="onDropdownOpenChange(dashboardsDropdown, $event)">
        <a class="sub-dropdown" id="module" ngbDropdownToggle> Dashboards
          <i class="fa fa-caret-right  float-end mt-5px" aria-hidden="true"></i>
        </a>
        <div ngbDropdownMenu aria-labelledby="static"
          class="dropdown-menu bg-light user-menus  sub-dropdown-menu drop_one">
      <li ngbDropdown placement="right" #processDashboardDropdown="ngbDropdown"
        (mouseenter)="openDropdownOnHover(processDashboardDropdown, $event)"
        (mouseleave)="closeDropdownOnLeave(processDashboardDropdown, $event)"
        (openChange)="onDropdownOpenChange(processDashboardDropdown, $event)">
        <a class="sub-dropdown" id="analysis" ngbDropdownToggle>Process <i class="fa fa-caret-right  float-end mt-5px"
            aria-hidden="true"></i>
        </a>
        <div class="dropdown-divider"></div>
        <div ngbDropdownMenu aria-labelledby="analysis" class="dropdown-menu bg-white user-menus  sub-dropdown-menu"
          style="left: 0px!important;top:66px;">
          <a ngbDropdownItem [routerLink]="['/reportlibrary/editreport', 'process']">Report Setting</a>
          <div class="dropdown-divider"></div>
          <a ngbDropdownItem routerLink="/dashboard/addDashboard">Custom Dashboard</a>
        </div>
      </li>
      <li ngbDropdown placement="right" #opexDashboardDropdown="ngbDropdown"
        (mouseenter)="openDropdownOnHover(opexDashboardDropdown, $event)"
        (mouseleave)="closeDropdownOnLeave(opexDashboardDropdown, $event)"
        (openChange)="onDropdownOpenChange(opexDashboardDropdown, $event)">
        <a class="sub-dropdown" id="analysis" ngbDropdownToggle>Opex <i class="fa fa-caret-right  float-end mt-5px"
            aria-hidden="true"></i></a>
        <div ngbDropdownMenu aria-labelledby="analysis" class="dropdown-menu bg-white user-menus  sub-dropdown-menu"
          style="left: 0px!important;top:32px;">
          <a ngbDropdownItem [routerLink]="['/reportlibrary/editreport', 'opex']">Report Setting</a>
          <div class="dropdown-divider"></div>
          <a ngbDropdownItem routerLink="/dashboard/addOpexDashboard">Custom Dashboard</a>
        </div>
      </li>
      </div>

  </li>
      <div class="dropdown-divider"></div>
      <a ngbDropdownItem routerLink="/site/manage-reports-updation">Manage Reports Updation</a>
  <!-- <li class="nav-item" ngbDropdown>
      <div class="dropdown-divider"></div>
      <a ngbDropdownItem routerLink="/equipment/equipmentsetting">Equipment Settings</a>
    </li> -->
  </ul>
  </li>

  <li class="nav-item" ngbDropdown #dashboardDropdown="ngbDropdown"
    (mouseenter)="openDropdownOnHover(dashboardDropdown, $event)"
    (mouseleave)="closeDropdownOnLeave(dashboardDropdown, $event)"
    (openChange)="onDropdownOpenChange(dashboardDropdown, $event)">
    <a class="nav-link text-white" ngbDropdownToggle id="dashboard" role="button">
      DASHBOARD <i class="fa fa-angle-down"></i>
    </a>
    <ul ngbDropdownMenu aria-labelledby="dashboard"
      class="dropdown-menu bg-light top-52px  shadow user_role border-none user-menus">
      <li ngbDropdown placement="left" #processDbDropdown="ngbDropdown"
        (mouseenter)="openDropdownOnHover(processDbDropdown, $event)"
        (mouseleave)="closeDropdownOnLeave(processDbDropdown, $event)"
        (openChange)="onDropdownOpenChange(processDbDropdown, $event)">
        <div ngbDropdown placement="bottom-right" #processDbInnerDropdown="ngbDropdown"
          (mouseenter)="openDropdownOnHover(processDbInnerDropdown, $event)"
          (mouseleave)="closeDropdownOnLeave(processDbInnerDropdown, $event)"
          (openChange)="onDropdownOpenChange(processDbInnerDropdown, $event)">
          <a class="sub-dropdown" id="Dashboard" ngbDropdownToggle>Process DB<i
              class="fa fa-caret-right  float-end mt-5px" aria-hidden="true"></i></a>
          <div ngbDropdownMenu aria-labelledby="Dashboard"
            class="dropdown-menu bg-light user-menus sub-dropdown-menu user_role drop_one">
            <a ngbDropdownItem routerLink="/dashboard/processdashboard"> Default DB</a>
            <div class="dropdown-divider"></div>
            <a ngbDropdownItem routerLink="/site/sitedashboard"> Custom DB</a>
          </div>
        </div>
        <div class="dropdown-divider"></div>
        <div ngbDropdown placement="bottom-right" #opexDbInnerDropdown="ngbDropdown"
          (mouseenter)="openDropdownOnHover(opexDbInnerDropdown, $event)"
          (mouseleave)="closeDropdownOnLeave(opexDbInnerDropdown, $event)"
          (openChange)="onDropdownOpenChange(opexDbInnerDropdown, $event)">
          <a class="sub-dropdown" id="Dashboard" ngbDropdownToggle>Opex Dashboard<i
              class="fa fa-caret-right  float-end mt-5px" aria-hidden="true"></i></a>
          <div ngbDropdownMenu aria-labelledby="Dashboard"
            class="dropdown-menu bg-light user-menus sub-dropdown-menu drop_one">
            <a ngbDropdownItem routerLink="/dashboard/opexdashboard"> Default DB</a>
            <div class="dropdown-divider"></div>
            <a ngbDropdownItem routerLink="/dashboard/customeOpexDashboard"> Custom DB</a>
          </div>
        </div>
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem routerLink="/corporation/corporate-dashboard"> Corporate Dashboard</a>
      </li>
    </ul>
  </li>
  <li class="nav-item" ngbDropdown>
    <a class="nav-link text-white" id="dashboard" role="button" (click)="aiPopShow('abc')">
      AI
    </a>
  </li>
  <!-- <li class="nav-item" ngbDropdown>
    <a class="nav-link text-white" ngbDropdownToggle id="static" role="button">
      ALERTS <i class="fa fa-angle-down" aria-hidden="true"></i>
    </a>
    <ul ngbDropdownMenu aria-labelledby="static"
      class="dropdown-menu bg-light top-52px  shadow border-none user-menus static">
      <li ngbDropdown placement="left">
        <a class="sub-dropdown" routerLink="/alerts/openalert" ngbDropdownItem>Open Alert</a>
        <div class="dropdown-divider"></div>
        <a class="sub-dropdown" routerLink="/alerts/historyalert" ngbDropdownItem>History Alert</a>
      </li>
    </ul>
  </li> -->
  <li class="nav-item ms-1" ngbDropdown #profileDropdown="ngbDropdown"
    (mouseenter)="openDropdownOnHover(profileDropdown, $event)"
    (mouseleave)="closeDropdownOnLeave(profileDropdown, $event)"
    (openChange)="onDropdownOpenChange(profileDropdown, $event)">
    <a class="nav-link" ngbDropdownToggle id="userauth" role="button">
      <img class="" src="./assets/images/avathar.jpg" height="40"
        style="border-radius: 50%;margin-top: -8px;height: 35px;">
    </a>
    <ul ngbDropdownMenu aria-labelledby="userauth" class="dropdown-menu bg-light top-52px logout shadow user-menus">
      <li ngbDropdown placement="left">
        <a class="sub-dropdown" routerLink="/account/privacy" ngbDropdownToggle><img src="assets/images/data-privacy.png" class="menu-icon" alt="" />
          My Data &amp; Privacy </a>
      </li>
      <li ngbDropdown placement="left">
        <a class="sub-dropdown" routerLink="/account/audit-logs" ngbDropdownToggle><img src="assets/images/logs.png" class="menu-icon" alt="" />
          Audit Logs </a>
      </li>
      <li ngbDropdown placement="left">
        <a class="sub-dropdown" id="library" (click)="logout()" ngbDropdownToggle><i class="fa fa-power-off"></i>
          Logout </a>
      </li>
    </ul>
  </li>
  </ul>
  </div>
</nav>

<div
  *ngIf="isAnyMenuOpen"
  class="menu-backdrop-blur">
</div>

<ng-template #resetPasswordModal let-modal>
  <div class="confirmation-header blue-theme-bg">
    <h5 class="modal-title text-white p-1">Reset User Password</h5>
    <span
      type="button"
      class="close table_user"
      aria-label="Close"
      (click)="closeResetPasswordModal()">
      <span aria-hidden="true">&times;</span>
    </span>
  </div>
  <div class="modal-body">
    <p class="text-danger small mb-3">
      This will replace the user's current password and sign them out from active sessions.
    </p>

    <div class="mb-3">
      <label for="resetTargetUser" class="form-label">Select User</label>
      <select
        id="resetTargetUser"
        class="form-control"
        [disabled]="resetUsersLoading || resetPasswordSubmitting"
        (change)="onResetUserChange($any($event.target).value)">
        <option value="">Select User</option>
        <option *ngFor="let user of resetPasswordUsers" [value]="user.user_id">
          {{ user.username }} - {{ user.email }}
        </option>
      </select>
      <small class="text-muted" *ngIf="resetUsersLoading">Loading users...</small>
    </div>

    <div class="reset-password-summary mb-3" *ngIf="selectedResetUser">
      <div><strong>Username:</strong> {{ selectedResetUser.username || '-' }}</div>
      <div><strong>Email:</strong> {{ selectedResetUser.email || '-' }}</div>
      <div><strong>Role:</strong> {{ getResetPasswordRoleLabel(selectedResetUser) }}</div>
    </div>

    <form [formGroup]="resetPasswordForm" (ngSubmit)="submitResetPassword()">
      <div class="mb-3">
        <label for="headerNewPassword" class="form-label">New Password</label>
        <input
          id="headerNewPassword"
          class="form-control"
          [type]="showResetPassword ? 'text' : 'password'"
          formControlName="newPassword"
          autocomplete="new-password"
          [disabled]="resetPasswordSubmitting" />
        <small class="text-danger" *ngIf="resetPasswordForm.get('newPassword')?.touched && resetPasswordForm.get('newPassword')?.hasError('required')">
          New Password is required.
        </small>
        <small class="text-danger" *ngIf="resetPasswordForm.get('newPassword')?.touched && resetPasswordForm.get('newPassword')?.hasError('minlength')">
          Password must be at least 8 characters.
        </small>
      </div>

      <div class="mb-2">
        <label for="headerConfirmPassword" class="form-label">Confirm Password</label>
        <input
          id="headerConfirmPassword"
          class="form-control"
          [type]="showResetPassword ? 'text' : 'password'"
          formControlName="confirmPassword"
          autocomplete="new-password"
          [disabled]="resetPasswordSubmitting" />
        <small class="text-danger" *ngIf="resetPasswordForm.get('confirmPassword')?.touched && resetPasswordForm.get('confirmPassword')?.hasError('required')">
          Confirm Password is required.
        </small>
        <small class="text-danger" *ngIf="resetPasswordForm.touched && resetPasswordForm.hasError('passwordMismatch')">
          New Password and Confirm Password must match.
        </small>
      </div>

      <div class="form-check mb-3">
        <input
          id="headerShowResetPassword"
          type="checkbox"
          class="form-check-input"
          [(ngModel)]="showResetPassword"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="resetPasswordSubmitting" />
        <label class="form-check-label" for="headerShowResetPassword">Show password</label>
      </div>

      <div class="confirmation-footer px-0 pb-0">
        <button
          type="submit"
          class="btn btn-sm btn-add-site-user m-1 text-white pe-3 ps-3"
          [disabled]="resetUsersLoading || resetPasswordSubmitting || resetPasswordForm.invalid || !selectedResetUser">
          {{ resetPasswordSubmitting ? 'Resetting...' : 'Reset Password' }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-cancel m-1 text-white pe-3 ps-3"
          (click)="closeResetPasswordModal()"
          [disabled]="resetPasswordSubmitting">
          Cancel
        </button>
      </div>
    </form>
  </div>
</ng-template>
